<script setup>
import { ref } from "vue";
import { gtag } from "analytics";

const ctime = toNumber(localStorage.getItem("consentTime"));

const show = ref(ctime + (180 * 86400000) < Date.now());

function toNumber(n) {
	const val = Number(n);

	return Number.isFinite(val) ? val : 0;
}

function consentUpdate() {
	gtag("consent", "update", {
		ad_user_data: "granted",
		ad_personalization: "granted",
		ad_storage: "granted",
		analytics_storage: "granted"
	});
}

function update() {
	localStorage.setItem("consentTime", Date.now());

	consentUpdate();

	show.value = false;
}

if (!show.value)
	consentUpdate();
</script>

<template>
	<div v-if="show" class="vix-consent grid gap-12">
		<div v-html="$gettext('We use essential cookies to make our service work. By using our website you agree to our %1.', '<a href=\'legal/cookie\'>' + $gettext('Cookie Policy') + '</a>')"></div>
		<button class="vui-btn" @click="update()">{{ $gettext("OK") }}</button>
	</div>
</template>
